import React from 'react'
import SectionTitle from './shared/SectionTitle'
import GradientText from './shared/GradientText'

export default function FeaturesSection() {
  const features = [
    {
      number: '01',
      title: '身份与基础信息核实',
      points: [
        '核对身份信息是否一致、是否存在明显异常',
        '发现信息不完整、不规范等问题时进行提示',
        '减少「冒名」「假身份」进入业务流程的情况',
      ],
      benefit: '先确认「这个人/这家公司到底是不是他自己说的那样」',
    },
    {
      number: '02',
      title: '法律与负面记录提醒',
      points: [
        '提示与对象相关的民事、刑事、行政等公开法律风险信号',
        '对执行信息、限制高消费等高敏感内容进行醒目标注',
        '方便业务人员在签约前多问一句、多确认一步',
      ],
      benefit: '避免合作后才发现「大问题」，减少走上诉讼和维权这条艰难的路',
    },
    {
      number: '03',
      title: '信用与偿付压力信号',
      points: [
        '在合规前提下，对与信贷行为、偿付压力相关的信号进行提示',
        '不简单粗暴地给出「黑/白」，而是给出风险等级与解释',
        '帮助你结合自身情况，决定是否需要提高押金、缩短账期等',
      ],
      benefit: '不是替你做决定，而是帮你知道「该不该更谨慎一点」',
    },
    {
      number: '04',
      title: '清晰易懂的风险报告',
      points: [
        '用等级、标签、简明文字展示风险概况',
        '把最重要的信息放在最显眼的位置，方便快速浏览',
        '支持导出、留档，方便内部沟通与事后复盘',
      ],
      benefit: '把复杂的信息，变成一份老板和一线员工都看得懂的报告',
    },
  ]

  return (
    <section className="py-32 bg-gradient-to-br from-gray-50 via-white to-orange-50/30 relative overflow-hidden">
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `radial-gradient(circle at 1px 1px, rgb(0 0 0 / 0.03) 1px, transparent 0)`,
          backgroundSize: '40px 40px',
        }}
      ></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
        <SectionTitle
          title="核心能力 · 一份报告，看清关键风险"
          subtitle="优查查不会给你一堆生硬的数据，而是把复杂信息整理成「看得懂、用得上」的风险报告，让一线业务也能快速做判断。"
        />

        <div className="space-y-16">
          {features.map((feature, index) => (
            <div key={index} className="group relative">
              <div className="flex gap-8 items-start">
                <div className="hidden lg:block relative">
                  <div className="text-[120px] font-bold text-transparent bg-clip-text bg-gradient-to-br from-orange-200 to-orange-100 leading-none select-none group-hover:from-orange-300 group-hover:to-orange-200 transition-all duration-500">
                    {feature.number}
                  </div>
                  <div className="absolute inset-0 text-[120px] font-bold leading-none select-none opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                    <GradientText>{feature.number}</GradientText>
                  </div>
                </div>

                <div className="flex-1 bg-white rounded-3xl p-8 lg:p-10 shadow-md hover:shadow-xl transition-all duration-500 group-hover:-translate-y-1 border border-gray-100">
                  <div className="lg:hidden mb-4">
                    <span className="text-5xl font-bold">
                      <GradientText>{feature.number}</GradientText>
                    </span>
                  </div>

                  <h3 className="text-3xl font-bold text-gray-900 mb-6">{feature.title}</h3>

                  <ul className="space-y-4 mb-6">
                    {feature.points.map((point, idx) => (
                      <li key={idx} className="flex items-start gap-3">
                        <div className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-gradient-to-br from-orange-500 to-orange-600 mt-2"></div>
                        <span className="text-gray-600 leading-relaxed">{point}</span>
                      </li>
                    ))}
                  </ul>

                  <div className="relative pl-6 border-l-4 border-orange-500 bg-gradient-to-r from-orange-50 to-transparent py-4 pr-6 rounded-r-2xl">
                    <p className="text-sm font-semibold text-gray-800">
                      <span className="text-orange-600">一句话好处：</span> {feature.benefit}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
